import { render, staticRenderFns } from "./CustomerOverview.vue?vue&type=template&id=863c4efc"
import script from "./CustomerOverview.vue?vue&type=script&lang=js"
export * from "./CustomerOverview.vue?vue&type=script&lang=js"
import style0 from "./CustomerOverview.vue?vue&type=style&index=0&id=863c4efc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports